import Vue from 'vue'


Vue.filter('formatDateTime', function (value) {
  if (!value) {
    return '';
  }

  let date = new Date(parseInt(value.replace("/Date(", "").replace(")/", ""), 10));
  if (date == "Invalid Date") {
    return ''
  }
  return date.format("yyyy-MM-dd HH:mm:ss")
});



// WEBPACK FOOTER //
// ./src/js/filter.js